<!-- CombinedComponent.vue -->
<template>
  <div style="color: rgb(255, 255, 255);fontsize=20px;padding-left:5px">
    <!-- <div class="title">
      <strong>{{ res && res.name }}</strong>
    </div> -->
    <div style="
        font-weight: bold;
        text-align: center;
        font-size: 1.5rem;
        margin-bottom: 1.5rem;
      ">
      {{ $t("sdwan.myNetwork") }}
    </div>
    <div style="font-weight: bold; ">
      {{ $t("sdwan.gateway") }}:
      {{ this.$store.state.sdwan.gateway }}
      <div class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after"
        style="padding-left: 0px;width: 120px;">
        <div class="weui-cell__bd container">
          <select class="weui-select" style="
            background-color: rgba(24, 24, 24, 0.4);
            fontsize: 20px;
            color: rgb(255, 255, 255);
           
          " v-model="this.$store.state.sdwan.mode">
            <option value="fullmesh" selected>
              {{ $t("sdwan.fullmeshMode") }}
            </option>
            <option value="central">
              {{ $t("sdwan.centralMode") }}
            </option>
          </select>

        </div>
        <div class="weui-cell__ft">
          <button type="button" v-on:click="showModeTip" class="weui-btn_reset weui-btn_icon">
            <i role="img" alt="帮助" class="js_target weui-icon-info-circle"></i>
          </button>
        </div>
      </div>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after" style="padding-left: 0px ">
      <div v-if="this.$store.state.sdwan.mode != 'central'" class="weui-cell__hd">
        {{ $t("sdwan.specifiedRelayNode") }}<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </div>
      <div v-if="this.$store.state.sdwan.mode == 'central'" class="weui-cell__hd">
        {{ $t("sdwan.centralNode") }}<span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </div>

      <div class="weui-cell__hd weui-cell weui-cell_active weui-cell_select weui-cell_select-after"
        style="padding-left: 0px;width: 200px;">
        <div class="weui-cell__bd container">
          <select class="weui-select" style="
            background-color: rgba(24, 24, 24, 0.4);
            fontsize: 20px;
            color: rgb(255, 255, 255);
           
          " v-model="this.$store.state.sdwan.centralNode">
            <option value="" selected>
              {{ $t("sdwan.notSpecified") }}
            </option>
            <option v-for="node in relayNodes" :key="node.name" :value="node.name">
              {{ node.name }}
            </option>
          </select>

        </div>

      </div>
      <div class="weui-cell__ft">
        <button type="button" v-on:click="showCentralTip" class="weui-btn_reset weui-btn_icon">
          <i role="img" alt="帮助" class="js_target weui-icon-info-circle"></i>
        </button>
      </div>
    </div>
    <div v-if="this.$store.state.sdwan.mode != 'central'"
      class="weui-cell__hd weui-cell weui-cell_active weui-cell_select weui-cell_select-after" style="
            background-color: rgba(24, 24, 24, 0.4);
            fontsize: 20px;
            color: rgb(255, 255, 255);
            padding-left: 0px;
           
          ">
      <p class="">{{ $t("sdwan.forceRelay") }}</p><span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
      <a class="">
        <input type="checkbox" class="switch is-success is-rounded is-primary"
          :checked="this.$store.state.sdwan.forceRelay == 1 && this.$store.state.sdwan.centralNode != ''" />

        <label class="switch-btn" style="padding-top:0rem" @click="this.$store.state.sdwan.forceRelay ^= 1"></label>
      </a>
    </div>
    <div class="weui-cell weui-cell_active weui-cell_select weui-cell_select-after" style="padding-left: 0px">
      <div class="weui-cell__bd container">
        <select class="weui-select" style="
            background-color:rgba(24, 24, 24, 0.4);;
            fontsize: 20px;
            color: rgb(255, 255, 255);
          " v-model="selectedMember">
          <option value="" disabled selected>
            {{ $t("sdwan.chooseSDWANMember") }}
          </option>
          <!-- 初始选项 -->
          <option v-for="node in selectingNodes" :key="node.name" :value="node.name">
            {{ node.name }}
            <p v-if="!node.isActive">({{ $t("offline") }})</p>
          </option>
        </select>
      </div>
      <div class="weui-cell__hd" style="padding-right: 5px">
        <a class="weui-btn weui-btn_mini" style="width: 80px; padding: 1px; background-color: rgb(0, 159, 255)"
          v-on:click="addMember" href="javascript:">{{ $t("join") }}</a>
      </div>
    </div>
    <div class="weui-cell_active" style="color: rgb(255, 255, 255)">
      <div class="member-list">
        <div class="list-header columns is-mobile">
          <div class="column is-two-fifth">{{ $t("sdwan.member") }}</div>
          <div class="column is-one-fifth">{{ $t("sdwan.virtualIP") }}</div>
          <div class="column is-two-fifth">{{ $t("sdwan.control") }}</div>
        </div>
        <div v-for="(member, index) in this.$store.state.sdwan.Nodes" :key="index" class="list-item columns is-mobile">
          <div class="column member-name column is-two-fifth">
            {{ member.name }}
          </div>
          <div class="column virtual-ip column is-one-fifth">
            {{ member.ip }}
          </div>
          <div class="column member-name column is-two-fifth">
            <p style="display: flex">
              <button class="weui-btn weui-btn_mini weui-btn_default weui-wa-hotarea" style="width: 3.5rem; padding: 1px"
                @click="editMember(index)">
                {{ $t("edit") }}
              </button>
              <button class="weui-btn weui-btn_mini weui-btn_warn weui-wa-hotarea" style="width: 3.5rem; padding: 0px"
                @click="removeMember(index)">
                {{ $t("delete") }}
              </button>
            </p>
          </div>
        </div>
      </div>

      <div class="weui-form__opr-area" style="padding-top: 20px">
        <a class="weui-btn weui-btn_primary" v-on:click="saveData" href="javascript:">{{ $t("save") }}</a>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios"
import weui from "weui.js"
const crc = require("crc")
export default {
  data() {
    return {
      selectedMember: "",
      specifiedRelayNode: "",
    }
  },
  computed: {
    selectingNodes() {
      const sdwan = this.$store.state.sdwan
      if (sdwan && sdwan.Nodes && this.$store.state.nodes.length > 1) {
        return this.$store.state.nodes.filter(
          (node) =>
            !sdwan.Nodes.some((member) => member.name === node.name)
        )
      }
      return this.$store.state.nodes
    },
    relayNodes() {
      const sdwan = this.$store.state.sdwan
      if (sdwan && sdwan.Nodes && this.$store.state.nodes.length > 1) {
        return this.$store.state.nodes.filter(
          (node) =>
            (node.natType == 1 || node.hasIPv4 == 1 || node.hasUPNPorNATPMP == 1) && node.isActive
        )
      }
      return this.$store.state.nodes
    },
  },
  methods: {
    async fetchData() {
      try {
        await this.$initDataOnce()
        // this.selectedMember = this.selectingNodes[0].name
        window.debugLog("selectedMode:", this.$store.state.sdwan.mode)
      } catch (error) {
        console.error("Error fetching data:", error)
      }
    },
    addMember() {
      const foundMember = this.selectingNodes.find(
        (member) => member.name === this.selectedMember
      )
      window.debugLog("find ", foundMember)
      if (this.$compareVersions(foundMember.version, "3.13.0") < 0) {
        weui.alert(this.$t("sdwan.versionLow"), {
          buttons: [
            {
              label: this.$t("ok"),
              onClick: function () { },
            },
          ],
        })
        return true
      }
      if (
        this.selectedMember &&
        (!this.$store.state.sdwan.Nodes ||
          !this.$store.state.sdwan.Nodes.some(
            (member) => member.name === this.selectedMember
          ))
      ) {
        window.debugLog("addmember ", this.selectedMember)
        const ip = this.generateUniqueIP(this.$store.state.sdwan.gateway)

        this.$store.state.sdwan.Nodes.push({
          name: this.selectedMember,
          ip: ip,
        })

        this.selectedMember = this.selectingNodes[0].name
      }
    },
    removeMember(index) {
      this.$store.state.sdwan.Nodes.splice(index, 1)
    },
    editMember(index) {
      this.$router.push({
        name: "EditMember",
        params: { index },
      })
    },

    generateUniqueIP(gateway) {
      const subnetParts = gateway.split("/")
      const gatewaySubnet = subnetParts[0]
      const subnetMask = parseInt(subnetParts[1], 10)
      const maxLastOctet =
        subnetMask === 32 ? 253 : (1 << (32 - subnetMask)) - 2 // Calculate the maximum last octet based on subnet mask

      let crcHash = crc.crc32(this.selectedMember).toString(16)
      let lastOctet = parseInt(crcHash, 16) % (maxLastOctet + 1)

      let generatedIP = this.generateIPFromLastOctet(lastOctet, gatewaySubnet)

      while (
        this.$store.state.sdwan.Nodes &&
        this.$store.state.sdwan.Nodes.some(
          (member) => member.ip === generatedIP
        )
      ) {
        // If the generated IP conflicts with an existing one, increment the last octet
        lastOctet = (lastOctet + 1) % (maxLastOctet + 1)
        generatedIP = this.generateIPFromLastOctet(lastOctet, gatewaySubnet)
      }

      return generatedIP
    },

    generateIPFromLastOctet(lastOctet, subnet) {
      const firstThreeOctets = subnet.split(".").slice(0, 3).join(".")
      return `${firstThreeOctets}.${lastOctet}`
    },

    saveData() {
      let _this = this
      if (this.$store.state.sdwan.mode == 'central' && this.$store.state.sdwan.centralNode == '') {
        weui.alert(_this.$t("sdwan.centralModeNotSpecifiedNode"), {
          buttons: [
            {
              label: _this.$t("ok"),
              onClick: function () { },
            },
          ],
        })
        return
      }
      // 遍历所有 SD-WAN 节点，收集版本号
      const versions = new Set();
      this.$store.state.sdwan.Nodes.forEach(sdwanNode => {
        // 在 this.$store.state.nodes 中查找具有相同名称的节点
        const node = this.$store.state.nodes.find(node => node.name === sdwanNode.name);
        if (node) {
          // 如果找到节点，则收集其版本号
          versions.add(node.version);
        }
      });
      var warning
      warning = ""
      // 如果版本号不止一个，表示版本不一致
      if (versions.size > 1) {
        // 输出提示信息，或者采取其他操作
        console.log("version inconsistent ", versions);
        warning += this.$t("sdwan.diffVer")
      }
      axios
        .post(
          `${this.$ServerHost}/api/v1/sdwan/edit`,
          this.$store.state.sdwan
        )
        .then((response) => {
          window.debugLog("Save successful:", response.data)
          weui.alert(_this.$t("saveOK") + "<br>" + warning, {
            buttons: [
              {
                label: _this.$t("ok"),
                onClick: function () { },
              },
            ],
          })
        })
        .catch((error) => {
          console.error("Error saving data:", error.response.status)
          if (error.response.status == 411) {
            weui.alert(_this.$t("sdwan.tooManyMembers"), {
              buttons: [
                {
                  label: _this.$t("ok"),
                  onClick: function () { },
                },
              ],
            })
          }
          // 可以根据需要处理保存失败后的逻辑
        })
    },
    showModeTip() {
      weui.alert(this.$t("sdwan.modeTips"), {
        buttons: [
          {
            label: this.$t("ok"),
            onClick: function () { },
          },
        ],
      })
      return
    },
    showCentralTip() {
      weui.alert(this.$t("sdwan.centralTips"), {
        buttons: [
          {
            label: this.$t("ok"),
            onClick: function () { },
          },
        ],
      })
      return
    },
  },

  mounted() {
    this.fetchData()
  },
}
</script>

<style scoped>
/* Add appropriate styling for the two-column list */
.member-list {
  margin-top: 10px;
}

.list-header {
  display: flex;
  font-weight: bold;
  margin-bottom: 5px;
}

.column {
  flex: 1;
  padding: 5px;
}

.member-name {
  text-align: left;
}

.virtual-ip {
  text-align: left;
}
</style>
<style scoped>
/* 样式可以根据需要自行调整 */
.save-button-container {
  text-align: center;
  margin-top: 20px;
}

.column {
  flex: 1;
  padding: 0.75rem;
}
</style>
<style lang="scss">
@import "../assets/css/card.scss";
</style>